import React from 'react';
import { Column, Row } from "../Layout/Grid";
import Text from "../Text";

import trackingOpen from "img/tracking-open.svg";
import trackingDone from "img/tracking-done.svg";
import trackingRefused from "img/tracking-error.svg";

import { ITrackItemDevolution } from './interface';
import DateOutput from "utils/DateOutput";

import { toZonedTime } from 'date-fns-tz';
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';

import "./styles.scss";

const TrackItemDevolution: React.FC<ITrackItemDevolution> = (props) => {
  const { item, indexCurrentItem, lastItemWithDate } = props;
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

  const dateStr = item.eventDate ? `${item.eventDate}` : null;
  // Converter a data ISO para o fuso horário e depois formatar
  const zonedDate = dateStr ? toZonedTime(parseISO(dateStr), timeZone) : null;
  const dateValid = zonedDate ? format(zonedDate, 'HH:mm', { locale: ptBR }) : null;

  function getStatusValue(): string {
    return item.description ?? "";
  }

  const setTrackingIcon = (key: string | undefined) => {
    let refusedList = ["Protocolo cancelado"];

    if (key && lastItemWithDate > indexCurrentItem) {
      return refusedList.includes(key) ?
        (<img src={trackingRefused} alt="" />) :
        (<img src={trackingDone} alt="" />);
    } else {
      if (key && item?.eventDate) {
        return refusedList.includes(key) ?
          (<img src={trackingRefused} alt="" />) :
          (<img src={trackingDone} alt="" />);
      }
    }

    return (<img src={trackingOpen} alt="" />);
  };

  const itemStyleOpacity = () => {
    if (lastItemWithDate > indexCurrentItem)
      return 1;

    return item.eventDate ? 1 : 0.5;
  };

  const styleItem = {
    opacity: itemStyleOpacity(),
    width: 100,
    maxWidth: 100,
  };

  return (
    <Row className="track-item">
      <Column
        className="align-center"
        style={styleItem}
      >
        {setTrackingIcon(item.description)}
        <Text
          size={14}
          className="mt-1 color-blue-gray text-center text-wrap text-overflow-none flex-1 text-uppercase-first-letter"
          width={100}
        >
          {getStatusValue()}
        </Text>
        <Column className="align-center mt-2">
          <Text size={12} className="color-blue-gray text-center">
            {item.eventDate ? (
              <DateOutput
                dateStr={item.eventDate}
                patternStr={"dd/MM/yyyy"}
              />
            ) : (
              "-"
            )}
          </Text>
          <Text size={12} className="color-blue-gray text-center">
            {item.eventDate && dateValid && dateValid !== '00:00' ? (
              <DateOutput dateStr={item.eventDate} patternStr={"HH:mm"} />
            ) : (
              "-"
            )}
          </Text>
        </Column>
      </Column>
    </Row>
  );
};

export default TrackItemDevolution;
